import { useId } from "$store/sdk/useId.ts";
import Icon from "$store/components/ui/Icon.tsx";
import Slider from "$store/components/ui/Slider.tsx";
import SliderJS from "$store/components/ui/SliderJS.tsx";
import ProductCard from "$store/components/product/content/BuyTogether/ProductCard.tsx";
import type { Product } from "apps/commerce/types.ts";

interface Props {
  products: Product[];
}

export default function Products({ products }: Props) {
  const sliderId = useId();

  return (
    <div id={sliderId} class="w-full min-w-0 h-full relative">
      <Slider class="carousel w-full h-full">
        {products.map((product, index) => (
          <Slider.Item class="carousel-item w-full" index={index}>
            <ProductCard product={product} />
          </Slider.Item>
        ))}
      </Slider>

      <Slider.PrevButton class="w-9 h-9 rounded-full bg-tw-primary-100 flex justify-center items-center absolute top-1/3 left-0 -translate-y-9 transition-opacity duration-300 disabled:opacity-50">
        <Icon
          id="ChevronRight"
          class="text-white -rotate-180"
          size={20}
          strokeWidth={3}
        />
      </Slider.PrevButton>

      <Slider.NextButton class="w-9 h-9 rounded-full bg-tw-primary-100 flex justify-center items-center absolute top-1/3 right-0 -translate-y-9 transition-opacity duration-300 disabled:opacity-50">
        <Icon
          id="ChevronRight"
          class="text-white"
          size={20}
          strokeWidth={3}
        />
      </Slider.NextButton>

      <SliderJS rootId={sliderId} />
    </div>
  );
}
